module.exports = __webpack_public_path__ + "static/media/memory_outro_bird_spritesheet.10f82de5.png";